// extracted by mini-css-extract-plugin
export default {"flipped":"Flashcard_flipped__Wez3M","container":"Flashcard_container__Kzvng"};